import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import apiClient, { withApiPath } from '../../utils/apiClient';
import LoadWorkspace from './LoadWorkspace';
import useLoadWorkspaceSync from './useLoadWorkspaceSync';
import { QuotesBookingsProvider } from '../quotes/QuotesBookingsContext';

const LoadWorkspacePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [load, setLoad] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [snapshotVersion, setSnapshotVersion] = useState(0);
  const [loadedId, setLoadedId] = useState(null);
  const [workspaceView, setWorkspaceView] = useState('shipment');
  const incorporateSnapshot = useCallback((snapshot) => {
    setLoad(snapshot);
    setLoadedId(String(snapshot?.id));
    setSnapshotVersion((value) => value + 1);
  }, []);
  const sync = useLoadWorkspaceSync(id, load, incorporateSnapshot);
  const closeWorkspace = useCallback(async () => {
    await sync.flushAndDrain();
    if (!sync.navigationRiskNow() || window.confirm('Unsaved shipment changes remain. Leave without saving?')) {
      navigate('/dashboard');
    }
  }, [navigate, sync]);

  useEffect(() => {
    let active = true;
    setLoad(null);
    setLoadedId(null);
    setIsLoading(true);
    setError('');
    setWorkspaceView('shipment');
    const fetchLoad = async () => {
      try {
        const response = await apiClient.get(withApiPath(`/loads/${id}/`));
        if (active) incorporateSnapshot(response.data);
      } catch (err) {
        if (!active) return;
        console.error('Failed to load workspace', err);
        setError('Unable to load this shipment right now.');
      } finally {
        if (active) setIsLoading(false);
      }
    };

    if (id) {
      fetchLoad();
    }
    return () => { active = false; };
  }, [id, incorporateSnapshot]);

  if (error) {
    return <div>{error}</div>;
  }

  if (isLoading || !load || loadedId !== String(id)) {
    return <div>Syncing real-time load data…</div>;
  }

  return (
    <QuotesBookingsProvider>
      <LoadWorkspace
        key={`${id}-${snapshotVersion}`}
        load={load}
        details={load}
        isLoading={isLoading}
        workspaceSync={sync}
        workspaceView={workspaceView}
        onWorkspaceViewChange={setWorkspaceView}
        onClose={closeWorkspace}
      />
    </QuotesBookingsProvider>
  );
};

export default LoadWorkspacePage;
